<template>
    <div class="cdc-customer-detail">
        <div class="full-container">
            <div class="top-navbar">
                <div class="row align-items-center">
                    <div class="col-md-4">
                        <div class="top-navbar-left">
                            <div class="btn-back" @click="$router.push({ name: 'cdcByBa' , params: { 'wpbaid': $route.params.wpbaid, 'wptlid': $route.params.wptlid, 'venue_id': $route.params.venue_id }});">
                                <font-awesome-icon :icon="['fas', 'angle-left']" />
                                Back
                            </div>
                        </div>
                    </div>

                    <div class="col-md-4">
                        <div class="top-navbar-center">View CDC Details</div>
                    </div>
                </div>
            </div>

            <hr />
        </div>

        <div class="container mt-5">

            <div class="mt-5">
                <ul class="nav custom-tab">
                    <div class="nav-link pointer active">CDC Details</div>
                </ul>
            </div>
            
            
            <form action="" class="readonly-form">
                <div class="reference-card">
                    <div class="row">
                        <div class="col-md-6">
                            <div class="form-group">
                                <label for="">Customer Name</label>
                                <input class="form-control" type="text" :value="cdcDetail.customer_name" readonly>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <label for="">Age</label>
                                <input class="form-control" type="text" :value="cdcDetail.age" readonly>
                            </div>
                        </div>
                    </div>

                    <div class="row">

                    </div>

                    <div class="row">
                        <div class="col-md-6">
                            <div class="form-group">
                                <label for="">Gender</label>
                                <input class="form-control" type="text" :value="cdcDetail.gender" id="gender" readonly>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <label for="">Contact No.</label>
                                <input class="form-control" type="text" :value="cdcDetail.contact_number" readonly>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-6">
                            <div class="form-group">
                                <label for="">Whatsapp</label>
                                <input class="form-control" type="text" :value="cdcDetail.whatsapp_num" readonly>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <label for="">Email</label>
                                <input class="form-control" type="text" :value="cdcDetail.email != 0 ? cdcDetail.email : '-'" readonly>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-6">
                            <div class="form-group">
                                <label for="">Occupation</label>
                                <input class="form-control" type="text" :value="cdcDetail.occupation" readonly>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <label for="">Address</label>
                                <input class="form-control" type="text" :value="cdcDetail.address" readonly>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-6">
                            <div class="form-group">
                                <label for="">KTP</label>
                                <input class="form-control" type="text" :value="cdcDetail.ktp != 0 ? cdcDetail.ktp : '-'" readonly>
                            </div>
                        </div>
                    </div>

                    <hr>

                    <div class="row">
                        <div class="col-md-6">
                            <div class="form-group">
                                <label for="">Purchased Product</label>
                                <input v-for="product in cdcDetail.product_name" :key="product.id" class="form-control" type="text" :value="product.name" readonly>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <label for="">Try Product Bentoel Before</label>
                                <input class="form-control" type="text" :value="cdcDetail.is_try_bentoel_before" readonly>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <label for="">Reason To Not Continue</label>
                                <input class="form-control" type="text" :value="cdcDetail.did_not_continue_reason != '' ? cdcDetail.did_not_continue_reason : '-'" readonly>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-6">
                            <div class="form-group">
                                <label for="">Receive Bentoel Communication</label>
                                <input class="form-control" type="text" :value="cdcDetail.receive_bentoel_communication" readonly>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <label for="">Preferred Communication</label>
                                <input class="form-control" type="text" :value="cdcDetail.preferred_communication_mode" readonly>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-6">
                            <div class="form-group">
                                <label for="">Above 18</label>
                                <input class="form-control" type="text" :value="cdcDetail.certify_details_true_above_18" readonly>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <label for="">Agree to be contact</label>
                                <input class="form-control" type="text" :value="cdcDetail.agree_to_be_contacted" readonly>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-6">
                            <div class="form-group">
                                <label for="">Comment</label>
                                <input class="form-control" type="text" :value="cdcDetail.consumer_comment != '' ? cdcDetail.consumer_comment : '-'" readonly>
                            </div>
                        </div>
                    </div>
                </div>

                <button type="button" class="mt-3 btn btn-ecdc btn-shadow" @click="$router.push({ name: 'cdcByBa' , params: { 'wpbaid': $route.params.wpbaid, 'wptlid': $route.params.wptlid }});">Back</button>
            </form>
            
        </div>

        <app-loader v-show="isLoading"></app-loader>
    </div>
</template>

<script>
import { getCustomerDetail } from '../api'
import Loader from './Loader.vue'

export default {
    components: {
        appLoader: Loader
    },
    data() {
        return {
            data: {
                customer_id: this.$route.params.cid,
                engagement_id: this.$route.params.eid
            },
            cdcDetail: "",
            isLoading: true
        }
    },
    async mounted() {

        await this.getCustomerDetail();
        this.isLoading = false;
    },
    methods: {
        async getCustomerDetail() {

            try {

                const result = await getCustomerDetail(this.data);
                this.cdcDetail = result.data.data;
            }
            catch(err) {

                alert(err.response.data.message);
            }
        }
    },
}
</script>